import { Component, Input, OnInit } from '@angular/core';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NzMenuModule, NzButtonModule, NzDividerModule, NzIconModule, RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  @Input() isCollapsed!: boolean;
  functions: string[] = [];
  isPreviewMode: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.isPreviewMode = this.router.url.startsWith('/preview-page');
    const userData = JSON.parse(localStorage.getItem('userData')!);
    this.functions = userData?.functions || [];
  }

  navigateTo(path: string): void {
    if (this.isPreviewMode) {
      return;
    }

    this.router.navigate([path]);
  }
}
